import { render, staticRenderFns } from "./InputWSuggestions.vue?vue&type=template&id=4ffd425c&scoped=true&"
import script from "./InputWSuggestions.vue?vue&type=script&lang=js&"
export * from "./InputWSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./InputWSuggestions.vue?vue&type=style&index=0&id=4ffd425c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd425c",
  null
  
)

export default component.exports